import React, { useEffect, useState } from 'react'
import { type PropsApp } from '../../../Types/HelpDesk/ManageDiary'
import { Button, Col, Modal, Row, Tooltip } from 'antd'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import {
    DeleteEvent,
    GetEventList,
} from '../../../Services/Helpdesk/ManageDiary'
import { useDispatch } from 'react-redux'
import FullWidthModal from '../../../Components/FullWidthModal'
import ManageDiaryForm from './ManagrDiaryForm'
import { ManageDairyDateFormat } from '../../../Utils/dateFormat'
const ManageDiaryList = (props: PropsApp): React.ReactElement => {
    const { selectedEvent, onDeleteEvent, setModaleventVisible, selectedDate } =
        props
    const [deleteModalVisible, setDeleteModalVisible] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)
    const dispatch = useDispatch()
    const [eventlist, setEventList] = useState(true)
    const [restData, setResetData] = useState('false')
    useEffect(() => {
        setModaleventVisible(eventlist)
    }, [eventlist])

    const handleDeleteClick = (): void => {
        setDeleteModalVisible(true)
    }
    const habndleeditclick = (): void => {
        setResetData('true')
        setModalVisible(true)
        setEventList(false)
    }
    const handleDeleteConfirm = (): void => {
        void handelDelete()
    }

    const handelDelete = async (): Promise<void> => {
        await DeleteEvent(dispatch, selectedEvent.eventId).then((result) => {
            if (result !== null && result !== undefined) {
                onDeleteEvent(selectedEvent.eventId)
                setDeleteModalVisible(false)
                GetEventList(dispatch)
            }
        })
    }

    const handleDeleteCancel = (): void => {
        setDeleteModalVisible(false)
    }
    const closeModal = (): void => {
        setModalVisible(false)
    }

    const userNames = selectedEvent?.generalEventFollowerList
        ?.map((follower: { userName: string }) => follower.userName)
        .join(', ')

    return (
        <div>
            <div>
                <p>Start: {ManageDairyDateFormat(selectedEvent.startFrom)}</p>
                <p>End: {ManageDairyDateFormat(selectedEvent.endTo)}</p>
                <p>Participant: {userNames}</p>
                <p>Description: {selectedEvent.description}</p>
                <Row gutter={16} justify="end">
                    <Col>
                        <Tooltip title="Delete Event">
                            <Button
                                type="primary"
                                onClick={() => {
                                    handleDeleteClick()
                                }}
                            >
                                <DeleteOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                    <Col>
                        <Tooltip title="Edit Event">
                            <Button type="primary" onClick={habndleeditclick}>
                                <EditOutlined />
                            </Button>
                        </Tooltip>
                    </Col>
                </Row>
            </div>

            <Modal
                title="Edit Event"
                open={modalVisible}
                onCancel={closeModal}
                footer={null}
                width={'50%'}
            >
                {selectedDate !== null && (
                    <ManageDiaryForm
                        date={selectedDate}
                        oncloseEventModal={closeModal}
                        initialFormData={selectedEvent}
                        resetdata={restData}
                        setResetData={setResetData}
                    />
                )}
            </Modal>
            <FullWidthModal
                modalStatus={deleteModalVisible}
                closeModal={handleDeleteCancel}
                tittle="You are about to delete all events. Click 'Yes' to continue."
                smallTittle="Warning: This action cannot be undone!"
                yesButtonFunction={handleDeleteConfirm}
            />
        </div>
    )
}

export default ManageDiaryList
